import type { IThemePage } from '~/stores/themePage';
import type { Campaign } from '~/types/graphql';

import { mapThemePageInfo, sortByConditions } from '~/utils';
import { parseVariantBadge } from '~/presentation/common';

export const getVariantsInfo = (campaign: Campaign, themePages?: IThemePage[]) => {
  const dataVariants = campaign.variants?.map((variant) => {
    const themePageInfo = mapThemePageInfo(variant?.templateSuffix, themePages);

    return {
      ...variant,
      id: variant?.id ?? '',
      badge: parseVariantBadge(variant),
      templateSuffix: variant?.templateSuffix ?? '',
      themePageInfo,
    };
  });
  return dataVariants ? sortByConditions(dataVariants, [{ attr: 'isOrigin' }]) : [];
};
